import { XIcon as XIcon_kojaro } from './XIcon.kojaro';
import { XIcon as XIcon_phosphor } from './XIcon.phosphor';
import { XIcon as XIcon_zoomg } from './XIcon.zoomg';
import { XIcon as XIcon_zoomit } from './XIcon.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return XIcon_kojaro;

    case 'zoomg':
      return XIcon_zoomg;

    case 'phosphor':
      return XIcon_phosphor;

    default:
      return XIcon_zoomit;
  }
};

export const XIcon = IconRenderer();
